import { Link } from 'react-router-dom'
import { Menu, MenuItem } from '@mui/material'
import useOverlay, { OverlayState } from '@/hooks/useOverlay'
import { ProjectCategory } from '@/types/projects'
import ProjectTemplateDialog from '../project-template-dialog/ProjectTemplateDialog'

type AddProjectMenuProps = {
  overlay: OverlayState
  category: ProjectCategory
}

export default function AddProjectMenu({
  overlay,
  category,
}: AddProjectMenuProps) {
  const chooseTemplateOverlay = useOverlay()
  return (
    <>
      <Menu
        id="help-menu"
        anchorEl={overlay.anchorEl as Element}
        open={overlay.isOpen}
        onClose={overlay.close}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem
          onClick={(e) => {
            chooseTemplateOverlay.open(e)
            overlay.close()
          }}
        >
          From Template
        </MenuItem>
        <MenuItem
          component={Link}
          to="/project-setup/details"
          state={{ category }}
        >
          Custom Project
        </MenuItem>
      </Menu>

      <ProjectTemplateDialog
        overlay={chooseTemplateOverlay}
        category={category}
      />
    </>
  )
}
